import { CarInterface } from '../fleet/types';
import { EmployeeInterface } from '../employees/types';
import { BlocksInterface } from '../terminals/types';
import { LineInterface, LineSectionBaseInterface } from '../lines/types';

/*
 * Action Types
 */
export enum DbdsTypes {
  LIST_DBDS_REQUEST = '@dbds/LIST_DBDS_REQUEST',
  LIST_DBDS_SUCCESS = '@dbds/LIST_DBDS_SUCCESS',
  LIST_DBDS_FAILURE = '@dbds/LIST_DBDS_FAILURE',

  GET_DBD_REQUEST = '@dbds/GET_DBD_REQUEST',
  GET_DBD_SUCCESS = '@dbds/GET_DBD_SUCCESS',
  GET_DBD_FAILURE = '@dbds/GET_DBD_FAILURE',

  CREATE_DBD_REQUEST = '@dbds/CREATE_DBD_REQUEST',
  CREATE_DBD_SUCCESS = '@dbds/CREATE_DBD_SUCCESS',
  CREATE_DBD_FAILURE = '@dbds/CREATE_DBD_FAILURE',

  UPDATE_DBD_REQUEST = '@dbds/UPDATE_DBD_REQUEST',
  UPDATE_DBD_SUCCESS = '@dbds/UPDATE_DBD_SUCCESS',
  UPDATE_DBD_FAILURE = '@dbds/UPDATE_DBD_FAILURE',

  DELETE_DBD_REQUEST = '@dbds/DELETE_DBD_REQUEST',
  DELETE_DBD_SUCCESS = '@dbds/DELETE_DBD_SUCCESS',
  DELETE_DBD_FAILURE = '@dbds/DELETE_DBD_FAILURE',

  REQUEST_STATUS_REQUEST = '@dbds/REQUEST_STATUS_REQUEST',
  REQUEST_STATUS_SUCCESS = '@dbds/REQUEST_STATUS_SUCCESS',
  REQUEST_STATUS_FAILURE = '@dbds/REQUEST_STATUS_FAILURE',

  GET_DBD_VERSION_REQUEST = '@dbds/GET_DBD_VERSION_REQUEST',
  GET_DBD_VERSION_SUCCESS = '@dbds/GET_DBD_VERSION_SUCCESS',
  GET_DBD_VERSION_FAILURE = '@dbds/GET_DBD_VERSION_FAILURE',

  GET_DBD_VERSION_LIST_REQUEST = '@dbds/GET_DBD_VERSION_LIST_REQUEST',
  GET_DBD_VERSION_LIST_SUCCESS = '@dbds/GET_DBD_VERSION_LIST_SUCCESS',
  GET_DBD_VERSION_LIST_FAILURE = '@dbds/GET_DBD_VERSION_LIST_FAILURE',

  DBD_VERSION_REQUEST_LIST_REQUEST = '@dbds/DBD_VERSION_REQUEST_LIST_REQUEST',
  DBD_VERSION_REQUEST_LIST_SUCCESS = '@dbds/DBD_VERSION_REQUEST_LIST_SUCCESS',
  DBD_VERSION_REQUEST_LIST_FAILURE = '@dbds/DBD_VERSION_REQUEST_LIST_FAILURE',

  VERSION_UPDATE_REQUEST_REQUEST = '@dbds/VERSION_UPDATE_REQUEST_REQUEST',
  VERSION_UPDATE_REQUEST_SUCCESS = '@dbds/VERSION_UPDATE_REQUEST_SUCCESS',
  VERSION_UPDATE_REQUEST_FAILURE = '@dbds/VERSION_UPDATE_REQUEST_FAILURE',

  CREATE_MANY_DBD_REQUEST = '@dbds/CREATE_MANY_DBD_REQUEST',
  CREATE_MANY_DBD_SUCCESS = '@dbds/CREATE_MANY_DBD_SUCCESS',
  CREATE_MANY_DBD_FAILURE = '@dbds/CREATE_MANY_DBD_FAILURE',
}

/*
 * Data types
 */
export interface DbdGpsStatus {
  lat: string;
  lng: string;
  timestamp: number;
}

export interface DbdStatus {
  dbdIp: string;
  dbdState: string;
  temperature: string;
  diskUsage: string;
  gps: DbdGpsStatus;
  applicationVersion: string;
  uptime: string;
  timestamp: string;
  oldStatusData?: DbdStatus;
  crashEvent?: string[];
  gpsStatus: number;
  internetStatus: number;
  memoryCard?: string;
  interface?: string;
  noSDCard?: string;
  sdProblem?: string;
  sdReadOnly?: string;
  settingsVersion?: string;
  validationNumber?: string;
  simCard: { carrier: string; iccid: string };
}

export interface BlockSchedule {
  id: string;
  title: string;
  status: number;
  weekdays: string;
  validFrom: Date;
  type: number;
  createdAt: Date;
  updatedAt: Date;
  blockId: string;
  supervisorId: string | null;
  employeeId: string | null;
  TransportSupervisor: object | null;
  TransportEmployee: object | null;
}

export interface BlockScheduleHour {
  id: string;
  hour: Date;
  createdAt: Date;
  updatedAt: Date;
  blockScheduleId: string;
  BlockSchedule: any;
}

export interface BlockScheduleHourGate {
  id: string;
  status: number;
  createdAt: Date;
  updatedAt: Date;
  blockScheduleHourId: string;
  gateId: string;
  BlockScheduleHour: BlockScheduleHour;
}

export interface BlockScheduleHourGateHistory {
  id: string;
  status: number;
  alreadyTriggered: boolean | null;
  createdAt: Date;
  updatedAt: Date;
  blockScheduleHourGateId: string;
  dbdConfigHistoryId: string;
  BlockScheduleHourGate: BlockScheduleHourGate;
}

export interface DbdConfigHistories {
  id: string;
  fromStatus: number;
  toStatus: number;
  createdAt: string;
  updatedAt: string;
  dbdId: string;
  employeeId: string;
  lineSectionId: string;
  Car?: CarInterface;
  LineSection?: LineSectionInterface;
  BlockScheduleHourGateHistories?: BlockScheduleHourGateHistory[];
  tripId: string;
  TransportEmployee: EmployeeInterface;
}

export interface LineSectionInterface extends LineSectionBaseInterface {
  Line: LineInterface;
}

export interface DbdInterface {
  id: string;
  carId?: string | null;
  blockId?: string | null;
  serial: string;
  createdAt?: string;
  updatedAt?: string;
  installer?: EmployeeInterface;
  statusData?: DbdStatus;
  Car?: CarInterface;
  Block?: BlocksInterface;
  LineSection?: LineSectionInterface;
  TransportEmployee?: EmployeeInterface;
  DbdConfigHistories?: DbdConfigHistories[];
  Gate?: {
    Block: {
      Terminal: { name: string };
    };
    title: string;
  };
  slot?: number;
  type?: number;
  way?: number;
  dbdInstallType?: string;
  dbdPlace?: string;
  DbdStatusHistories?: {
    createdAt: string;
    dbdId: string;
    id: string;
    statusData: string;
    updatedAt: string;
  };
  DbdVersionRequests?: Array<{
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    DbdVersion: {
      id: string;
      title: string;
      description: string;
      allowToReturnTo: string;
      allowToUpgradeFrom: string;
      createdAt: string;
      updatedAt: string;
      transportOperatorId: string;
    };
  }>;
}

export interface DbdVersionListInterface {
  id: string;
  title: string;
  description: string;
  allowToReturnTo: Array<string>;
  allowToUpgradeFrom: Array<string>;
  createdAt: Date;
  updatedAt: Date;
}

export interface DbdVersionRequestHistoriesInterface {
  id: string;
  type: number;
  createdAt: string;
  updatedAt: string;
  dbdVersionRequestId: string;
}
export interface DbdVersionRequestInterface {
  createdAt: string;
  dbdId: string;
  id: string;
  dbdVersionId: string;
  updatedAt: string;
  DbdVersionRequestHistories: DbdVersionRequestHistoriesInterface[];
}

/*
 * State type
 */
export interface DbdsState {
  readonly dbdsList: DbdInterface[];
  readonly dbdData: DbdInterface;
  readonly dbdVersionRequestList: DbdVersionRequestInterface | null;
  readonly dbdVersionList: DbdVersionListInterface[];
  readonly dbdVersionData: DbdVersionListInterface | null;
  readonly versionUpdateList: any[];
  readonly loading: boolean;
  readonly error: boolean;
}
